import { ContinueResponse, Endpoint } from '../class/class';
import { Constants, SigningMethod } from '../enums/const-enums';
import {
  handleContinueResponse,
  httpRequest,
  logd,
  setCookie,
} from '../utils/utils';

export class GenerateEotpRequest {
  email_address: string;

  constructor(emailAddress: string) {
    this.email_address = emailAddress;
  }
}

export class VerifyEotpRequest {
  email_address: string;
  one_time_password: string;

  constructor(emailAddress: string, oneTimePassword: string) {
    this.email_address = emailAddress;
    this.one_time_password = oneTimePassword;
  }
}

export class EotpService extends Endpoint {
  static generate_endpoint = 'qsl_generate_eotp';
  static verify_endpoint = 'qsl_verify_eotp';

  constructor() {
    super();
  }

  doRequestEotp(emailAddress: string): Promise<AppModel.HttpResponse<unknown>> {
    const req = new GenerateEotpRequest(emailAddress);
    logd(() =>
      console.log('%c generateEotp -> %c', 'color:#F60', 'color:#000', req),
    );
    return httpRequest(this.baseUrl + EotpService.generate_endpoint, req);
  }

  async doVerifyEotp(
    emailAddress: string,
    oneTimePassword: string,
  ): Promise<void> {
    const req = new VerifyEotpRequest(emailAddress, oneTimePassword.trim());
    logd(() =>
      console.log('%c verifyEotp -> %c', 'color:#F60', 'color:#000', req),
    );
    const resp = await httpRequest(
      this.baseUrl + EotpService.verify_endpoint,
      req,
    );
    setCookie(Constants.METHOD_COOKIE_NAME, SigningMethod.EOTP.toLowerCase());
    return handleContinueResponse(new ContinueResponse(resp.json), 'success');
  }
}
